"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTurnedOffNotification = exports.removeTurnOffNotification = void 0;
var global_1 = require("../../stores/global");
var player_1 = require("../../stores/player");
var _kernel_store_types_1 = require("../../types");
var showNotification_1 = __importDefault(require("../showNotification"));
var notifications_1 = require("../../stores/notifications");
var turnedOffNotificationKey = "TurnOnOffMode";
function setTurnedOff() {
    var action = function (dispatch, getState) {
        dispatch((0, global_1.setTurnedOnState)(false));
        dispatch(showTurnedOffNotification([
            "Вещание остановлено. Обратитесь в отдел аккаунтинга",
            " по номеру: 8 (800) 550-59-94 (доб. 3).",
        ]));
        dispatch((0, player_1.setCurrentPlayState)(_kernel_store_types_1.EPlayState.STOP));
    };
    action.type = setTurnedOff.type;
    return action;
}
setTurnedOff.type = "setTurnedOff";
exports.default = setTurnedOff;
function showTurnedOffNotification(text) {
    return (0, showNotification_1.default)({
        type: _kernel_store_types_1.EInAppNotificationType.ERROR,
        key: turnedOffNotificationKey,
        text: text,
        closable: false,
    });
}
function removeTurnOffNotification(id) {
    return (0, notifications_1.removeNotification)(id);
}
exports.removeTurnOffNotification = removeTurnOffNotification;
function selectTurnedOffNotification(state) {
    var matchingNotifications = state.notifications.filter(function (notification) {
        return notification.key === turnedOffNotificationKey;
    });
    return matchingNotifications.length === 1 ? matchingNotifications[0] : null;
}
exports.selectTurnedOffNotification = selectTurnedOffNotification;
//# sourceMappingURL=setTurnedOff.js.map